import { render } from "./texture.vue?vue&type=template&id=74c1c3b8&scoped=true"
import script from "./texture.vue?vue&type=script&lang=js"
export * from "./texture.vue?vue&type=script&lang=js"

import "./texture.vue?vue&type=style&index=0&id=74c1c3b8&lang=scss&scoped=true"
import "./texture.vue?vue&type=style&index=1&id=74c1c3b8&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c1c3b8"]])

export default __exports__